import { FlowIcon } from "@/components/shared/icons"
import AspectRatio from "@/components/AspectRatio"

interface WorkflowPlaceholderProps {
  stretch?: boolean
}

const WorkflowPlaceholder = ({ stretch }: WorkflowPlaceholderProps) => {
  if (stretch) {
    return (
      <AspectRatio ratio={1 / 1} className="w-full h-full">
        <div className="flex h-full w-full items-center justify-center">
          <FlowIcon className="text-atherGray-800" />
        </div>
      </AspectRatio>
    )
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <FlowIcon className="text-atherGray-800" />
    </div>
  )
}

export default WorkflowPlaceholder
